module.exports = __webpack_public_path__ + "img/float_btn_fold.76a5769e.png";